import { Backdrop, CircularProgress } from '@mui/material';
import { JSX } from 'react';

type Props = {
  loaderVisible: boolean;
}

export const BackdropLoader = ({ loaderVisible }: Props): JSX.Element => {
  return <Backdrop
    // manually setting "aria-hidden" here because of bug, it's always set to true (even when backdrop is visible)
    // this causes that DOM queries (e.g. in tests) cannot find children elements as their consider backdrop and all it's content as hidden
    // this can be removed after resolving this:
    // https://github.com/mui/material-ui/issues/33146
    aria-hidden={!loaderVisible}
    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
    open={loaderVisible}
  >
    <CircularProgress color="inherit" />
  </Backdrop>;
};
